function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapMarker = function SvgMapMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.9969 8.64733C15.9969 13.4229 8.00002 21 8.00002 21C8.00002 21 0.00318534 13.4229 0.00318534 8.64733C-0.0574836 6.41815 0.750558 4.25549 2.24989 2.63419C3.74922 1.0129 5.81729 0.0654923 8.00002 0C10.1826 0.0658998 12.2504 1.01343 13.7497 2.63463C15.2489 4.25584 16.0571 6.41826 15.9969 8.64733Z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
    fill: props.fill
  }));
};
export default SvgMapMarker;